module.exports = __webpack_public_path__ + "static/media/homepage_shortened.c2b0980c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/gtmobile/src/homepage_shortened.gif
// module id = 111
// module chunks = 0